module.exports = __webpack_public_path__ + "static/media/accounting.242157b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/accounting.svg
// module id = 375
// module chunks = 0